import { motion } from 'framer-motion';
import styled from 'styled-components/macro';
import StyledFlexContainer from './StyledFlexContainer';

const SkillsItem = styled(motion(StyledFlexContainer))`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 1rem;
	transition: all 0.3s ease-in-out;
	gap: 0.5rem;
	@media screen and (min-width: 2000px) {
		margin: 1rem 2rem;
		gap: 1rem;
	}
`;

export default SkillsItem;
